import { type CarrierDef } from '../common.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type moncCredType = (typeof credentialTypes)[number]
export const monc: CarrierDef<moncCredType> = {
  name: 'Monroe Transportation Services',
  scac: 'monc',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['rating'],
}
